import {Circle, Map, Marker, Popup, TileLayer} from 'react-leaflet'
import React from 'react'
import 'react-leaflet-fullscreen-control';
import {LeafletMouseEvent} from 'leaflet'
import {selPropGenString} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {useSelector} from 'react-redux'

const _noop = () => {
};

export type MapType = "roadmap" | "satellite"

export interface GpsComponentProps {
	lat?: number;
	lon?: number;
	acc?: number;
	showAccuracy: boolean;
	disabled: boolean;
	fullscreenControl: boolean;
	attributionControl?: boolean;
	maptype?: MapType;
	zoom: number;

	onChange(event: LeafletMouseEvent): void;

}

const GEO_API_BASE_URL = "../json/requestTiles/{s}/{z}/{x}/{y}";
const DEFAULT_ATTRIBUTION = 'Datenquelle: <a href="https://www.basemap.at">basemap.at</a>';

function GPSComponent({lat, lon, acc, disabled, onChange, fullscreenControl, maptype = 'roadmap', attributionControl = true, zoom, showAccuracy}: GpsComponentProps) {

	const selGeoMapAttribution = useSelector(selPropGenString(PropID.eventDialog_geoMapAttribution, DEFAULT_ATTRIBUTION));

	if (!lat || !lon) return null;
	const url = GEO_API_BASE_URL + "?" + "maptype=" + encodeURIComponent(maptype) + "&location=" + encodeURIComponent(lat + "," + lon);
	return <Map style={{height: 200}}
							center={[lat, lon]}
							zoom={zoom}
							dragging={!disabled}
							zoomControl={true}
							scrollWheelZoom={true}
							onclick={disabled && _noop || onChange}
							doubleClickZoom={false}
							enableHighAccuracy={true}
							fullscreenControl={fullscreenControl}
							attributionControl={attributionControl}
	>
		<TileLayer attribution={selGeoMapAttribution || ""} url={url}/>
		{(showAccuracy && acc) && <Circle center={[lat, lon]} radius={acc}/>}
		<Marker position={[lat, lon]}>
			<Popup>
				<span>latitude: {lat}<br/>longitude: {lon}</span>
			</Popup>
		</Marker>
	</Map>
}

export default GPSComponent;